import { useCallback, useRef } from 'react';
import { trackStepErrorViewed } from '../../../shared/analytics';
import { normalizeErrorMessage } from '../../../shared/utils';
import { getFormName } from './getFormName';

type StepErrorType = 'validation' | 'system';

// Repeated identical validation errors (e.g. a held Enter key) are sent once; system failures always are.
function useTrackStepError(step: number, stepName: string, stepLabel: string) {
  const sentValidationErrors = useRef(new Set<string>());

  return useCallback(
    (
      errorType: StepErrorType,
      errorMessage: string | undefined,
      errorField?: string
    ) => {
      if (!errorMessage) return;
      const message = normalizeErrorMessage(errorMessage);
      if (errorType === 'validation') {
        const key = `${errorField ?? ''}|${message}`;
        if (sentValidationErrors.current.has(key)) return;
        sentValidationErrors.current.add(key);
      }
      trackStepErrorViewed({
        step,
        step_name: stepName,
        step_label: stepLabel,
        error_type: errorType,
        error_message: message,
        error_field: errorField,
        form_name: getFormName()
      });
    },
    [step, stepName, stepLabel]
  );
}

export { useTrackStepError };
